module.exports = __webpack_public_path__ + "img/exam_jan_2025_ai1fym41.59755a6f.jpg";